export const levels = [
  {
    value: "1",
    name: "High School",
  },
  {
    value: "2",
    name: "College",
  },
  {
    value: "3",
    name: "University",
  },
  {
    value: "4",
    name: "Master's",
  },
  {
    value: "5",
    name: "Ph.D.",
  },
];
